import React from 'react'
import { SwitchContainer, SwitchLabel, SwitchThumb, SwitchTrack } from './Switch.styles'

export interface SwitchProps {
  isActive: boolean
  onChange: (isActive: boolean) => void
  label?: string
  disabled?: boolean
}

const Switch: React.FC<SwitchProps> = ({
  isActive,
  onChange,
  label,
  disabled = false
}) => {
  const handleToggle = () => {
    if (!disabled) {
      onChange(!isActive)
    }
  }

  return (
    <SwitchContainer>
      {label && <SwitchLabel>{label}</SwitchLabel>}
      <SwitchTrack
        $isActive={isActive}
        onClick={handleToggle}
        style={{ opacity: disabled ? 0.5 : 1, cursor: disabled ? 'not-allowed' : 'pointer' }}
      >
        <SwitchThumb $isActive={isActive} />
      </SwitchTrack>
    </SwitchContainer>
  )
}

export default Switch
